export const brand = {
  name: 'COMMON',
  descriptor: 'Community Property Management',
};

export const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'Communities', to: '/communities' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export const heroAssets = {
  background: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/3cd5c3ee-c964-4029-a3d2-c2e13e209419_hero_bg.webp',
  foreground: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/3cd5c3ee-c964-4029-a3d2-c2e13e209419_hero_fg.webp',
  master: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/3cd5c3ee-c964-4029-a3d2-c2e13e209419_hero_master.webp',
};

export const coreServices = [
  {
    id: 'operations',
    title: 'Community Operations',
    summary: 'Daily coordination of vendors, schedules, inspections and board requests so the community runs on a predictable rhythm.',
    tasks: ['Vendor scheduling and oversight', 'Routine site inspections', 'Board meeting preparation'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_svc-ops.webp',
  },
  {
    id: 'maintenance',
    title: 'Building & Facility Maintenance',
    summary: 'Preventive and responsive upkeep for building systems, common interiors and exterior envelopes, documented and tracked.',
    tasks: ['Preventive maintenance calendars', 'Work order tracking', 'Contractor bid coordination'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_svc-maint.webp',
  },
  {
    id: 'grounds',
    title: 'Grounds & Shared Spaces',
    summary: 'Landscaping, amenity areas, walkways and seasonal care for the spaces residents use together every day.',
    tasks: ['Landscape contract management', 'Amenity and pool upkeep', 'Seasonal and snow planning'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_svc-grounds.webp',
  },
  {
    id: 'resident',
    title: 'Resident Support',
    summary: 'A clear way for residents to ask questions, report issues and receive timely, courteous follow-up.',
    tasks: ['Service request intake', 'Community notices', 'Move-in and move-out guidance'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_svc-resident.webp',
  },
];

export const galleryItems = [
  {
    id: 'exteriors',
    label: 'Property exteriors',
    caption: 'Facades, entries and building envelopes kept clean, safe and in good repair.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_gal-ext.webp',
  },
  {
    id: 'maintenance',
    label: 'Maintenance',
    caption: 'Scheduled inspections and repairs handled before small issues become larger ones.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_gal-maint.webp',
  },
  {
    id: 'common-spaces',
    label: 'Common spaces',
    caption: 'Lounges, lobbies and amenity rooms prepared for everyday use by every resident.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_gal-common.webp',
  },
  {
    id: 'landscape',
    label: 'Landscape',
    caption: 'Paths, planting and lawns cared for through the seasons.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_gal-land.webp',
  },
  {
    id: 'resident-life',
    label: 'Resident life',
    caption: 'Shared places that feel welcoming because someone looks after them.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_gal-life.webp',
  },
];

export const communityTypes = [
  {
    id: 'condominiums',
    title: 'Condominium Communities',
    summary: 'Support for condominium boards balancing shared building systems, reserve planning and the expectations of individual owners.',
    focus: ['Board and owner communication', 'Common element maintenance', 'Reserve and budget coordination'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_comm-condo.webp',
  },
  {
    id: 'apartments',
    title: 'Apartment Communities',
    summary: 'Operational management for owners and operators who need consistent resident service and well-kept common areas.',
    focus: ['Resident request handling', 'Turnover and unit readiness support', 'Amenity and grounds care'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_comm-apt.webp',
  },
  {
    id: 'neighborhoods',
    title: 'Planned Residential Neighborhoods',
    summary: 'Coordination for homeowners associations responsible for streetscapes, shared amenities and community guidelines.',
    focus: ['Shared amenity oversight', 'Architectural request coordination', 'Common area landscaping'],
    image: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_comm-hoa.webp',
  },
];

export const approachSteps = [
  {
    title: 'Listen',
    text: 'We start by walking the property with the board or owner, reviewing current contracts, open issues and what residents most often ask about.',
  },
  {
    title: 'Plan',
    text: 'Together we set maintenance priorities, communication routines and a realistic annual calendar that fits the approved budget.',
  },
  {
    title: 'Manage',
    text: 'Day to day, we coordinate vendors, respond to requests, keep records current and report back on a schedule you agree to.',
  },
  {
    title: 'Improve',
    text: 'Each year we review what worked, what residents reported and what the building needs next, and adjust the plan accordingly.',
  },
];

export const splitImages = {
  homeIntro: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_split-intro.webp',
  admin: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_split-admin.webp',
  preventive: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_split-prevent.webp',
  tailored: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_split-tailor.webp',
  shared: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_split-shared.webp',
  about: 'https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_split-about.webp',
};